import React,{Component} from 'react';
import ForgotPassword from '../../containers/ForgotPassword';
import companyLogo from '../../assets/proactive_logo.png';
import '../../css/views/loginview.css';

/**
 * This component is used to make a view for Login page view.
 * @ignore
 */
class ForgotPasswordView extends Component{
    render(){
        return(
            <div className="container-fluid">
                <div className="row">
                    <div className="col-2">
                        <img className="company-image" src={companyLogo} alt="company-logo"/>
                    </div>
                </div>
                <div className="container h-100 d-flex justify-content-center">
                    <div className="row align-items-center">
                        <div className="col align-self-center">
                            <ForgotPassword/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgotPasswordView;